import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faArrowUpRight} from '@fortawesome/pro-solid-svg-icons/faArrowUpRight'
import {faShieldCheck} from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import {Author} from '../../../../core/content/types/author.types'

@Component({
  selector: 'bgo-authors',
  templateUrl: './authors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthorsComponent {
  @Input() authors: Author[] = []

  verifiedIcon = faShieldCheck
  ctaIcon = faArrowUpRight

  // calculate the portrait size based on the intrinsic size of the image,
  // respecting the aspect ratio and the height constraint on the component
  portraitSize(intrinsicSize: {width: number; height: number}): {width: number; height: number} {
    const fixedLogoHeight = 32
    const aspectRatio = intrinsicSize.height / intrinsicSize.width
    return {width: Math.round(fixedLogoHeight / aspectRatio), height: fixedLogoHeight}
  }
}
